

















import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import { registerForm } from '@/fixtures/register'
import { FormRegister } from '@/types'
import { goToPrequalification } from '@/lib/redirection'

@Component
export default class RegisterThanksYou extends Vue {
  // state

  registerForm: FormRegister = registerForm

  // methods

  onClickView(){
    goToPrequalification()
  }

  onBackToWebsite() {
    this.$router.push({ name: "home" })
  }
}
